import {Box, Stack, Typography} from "@mui/joy";
import { JunbeeLogo } from './JunbeeLogo';

export function Logo() {
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <JunbeeLogo />
      <Typography sx={{ fontSize: '20px', fontWeight: 800, letterSpacing: '-0.045em', color: 'neutral.900' }}>
        junbee
      </Typography>
    </Stack>
  )
}
